module.exports = __webpack_public_path__ + "static/media/place.8de91447.png";